import React from "react";
import CustomCheckbox from "./customCheckbox";
import { SFStarRoundedIcon, SFStarBorderRoundedIcon } from "../icons";
import { PROPS as IconProps } from "../icons/props";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const StyledCheckbox = styled(CustomCheckbox)(({ theme, hoverLabel }) => ({
  ...(hoverLabel && {
    "&:after": {
      content: `'${hoverLabel}'`,
      position: "relative",
      right: `-${theme.spacing(1)}`,
      display: "none",
    },
    "&:hover:after": {
      display: "block",
      lineHeight: "inherit"
    },
  }),
}));

const SFStarCheckbox = ({
  onChange,
  size = "medium",
  checked = false,
  disabled = false,
  color = "black",
  label,
  onClick,
  className
}) => {
  return (
    <StyledCheckbox
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      hoverLabel={label}
      className={className}
      checkboxVariant="favorite"
      icon={<SFStarBorderRoundedIcon size={size} color={color} />}
      checkedIcon={<SFStarRoundedIcon size={size} color={color} />}
      onClick={onClick}

    />
  );
};

SFStarCheckbox.propTypes = {
  /* Size of the star checkbox. */
  size: IconProps.size,
  /* Color of the star checkbox. */
  color: IconProps.color,
  /* Hover label of the star checkbox */
  label: CustomCheckbox.propTypes.label,
  /* If true, the component is checked. */
  checked: CustomCheckbox.propTypes.checked,
  /* If true, the component is disabled. */
  disabled: CustomCheckbox.propTypes.disabled,
  /* Callback fired when the state is changed.*/
  onChange: CustomCheckbox.propTypes.onChange,
};

export default SFStarCheckbox;
